import { ButtonBase, CircularProgress } from '@mui/material';
import React from 'react';
import { NumericFormat } from 'react-number-format';

const RoomQuantityCard = ({
  icon,
  color,
  value,
  analyticData,
  title,
  status,
  onClick = () => {},
}) => {
  return (
    <ButtonBase
      className={`${status} homes-item-wrapper !shadow-md !base-border !h-auto`}
      onClick={() => onClick(value)}
    >
      <div className='homes-item-number'>
        {analyticData.isLoading || analyticData.isFetching ? (
          <div className='flex my-2'>
            <CircularProgress size={32} color='inherit' />
          </div>
        ) : (
          <div className='flex flex-col gap-1'>
            <i className={`${icon} text-2xl`}></i>
            <NumericFormat
              value={value}
              displayType={'text'}
              allowNegative={false}
              thousandSeparator={' '}
              decimalScale={3}
              className={`${color} bg-transparent`}
            />
          </div>
        )}
      </div>
      <div className='homes-item-status-name text-black'>{title}</div>
    </ButtonBase>
  );
};

export default RoomQuantityCard;
